import { StepStatus } from "../constants";

const defaultGetStatus = (index: number, currentStep: number): StepStatus => {
  if (index < currentStep) return "completed";
  if (index === currentStep) return "current";
  return "upcoming";
};
export {defaultGetStatus}